export const SEND_APP_DOWNLOAD_TEXT = 'send-app-download-text';
const sendAppDownloadText = ({ phone }) => ({
  type: SEND_APP_DOWNLOAD_TEXT,
  payload: { phone },
});
export default sendAppDownloadText;
